import { observer } from 'mobx-react'
import { useQuery } from 'react-query'
import { useHistory } from 'react-router'
import AppContainer from '../../App/Container'
import { ReactComponent as ArrowLeft } from '../../assets/images/icons/arrow-left.svg'
import { ReactComponent as ChevronDownIcon } from '../../assets/images/icons/arrow-ios-down.svg'
import { useEffect, useState } from 'react'
import ReactMarkdown from 'react-markdown'
import RehypeRaw from 'rehype-raw'
import style from './FaqPage.module.css'

const FaqPage = observer(() => {
  const { push } = useHistory()
  const [activeItem, setActiveItem] = useState(-1)
  const { data } = useQuery(
    'faq',
    async () => {
      return await fetch(
        process.env.REACT_APP_STRAPI_URL + '/articles?_where[category.slug]=faq'
      ).then(async (res) => await res.json())
    },
    {
      staleTime: 1_000_000
    }
  )

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const toggleActiveItem = (id: number) => {
    if (activeItem === id) {
      setActiveItem(-1)
      return
    }

    setActiveItem(id)
  }

  return (
    <div className="pb-10">
      <div
        className="bg-white py-7 px-12 flex items-center cursor-pointer"
        onClick={() => {
          push('/')
        }}
      >
        <ArrowLeft />
        <div className="ml-6">zurück zur Startseite</div>
      </div>
      <AppContainer>
        <h1 className={style.headline}>FAQ</h1>
        <div className={style.content}>
          {(data || []).map((e) => {
            return (
              <div key={e.id} className="bg-white p-6 rounded shadow">
                <div
                  className="flex justify-between items-center cursor-pointer"
                  onClick={() => {
                    toggleActiveItem(e.id)
                  }}
                >
                  <h4>{e.title}</h4>
                  <ChevronDownIcon
                    className={
                      'w-6 h-6 fill-current transform-gpu transition-all ' +
                      (activeItem === e.id ? 'rotate-180' : '')
                    }
                  />
                </div>
                <div
                  className={
                    'grid gap-8 mt-4 ' +
                    (e.article_media ? 'grid-cols-2 ' : '') +
                    (activeItem === e.id ? '' : 'hidden')
                  }
                >
                  {e.article_media && (
                    <div>
                      <img
                        src={e.article_media.image.url}
                        alt={
                          e.article_media.alternative ||
                          e.article_media.image.alternativeText
                        }
                        title={e.article_media.title}
                      />
                      <p className="text-gray-manatee text-sm">
                        {e.article_media.caption}
                      </p>
                    </div>
                  )}
                  <div className="grid gap-4">
                    <div className="text-lg font-bold">{e.title}</div>
                    {e.content.map((c) => {
                      if (c.image) {
                        return (
                          <div key={e.id + '-image-' + c.id}>
                            <img
                              src={c.image.url}
                              alt={c.alternative || c.image.alternativeText}
                              title={c.title}
                            />{' '}
                            {c.caption && (
                              <p className="text-gray-manatee text-sm">
                                {c.caption}
                              </p>
                            )}
                          </div>
                        )
                      }
                      if (c.code) {
                        return (
                          <div
                            key={e.id + '-code-' + c.id}
                            dangerouslySetInnerHTML={{
                              __html: c.code
                            }}
                          />
                        )
                      }
                      return (
                        <div key={e.id + '-content-' + c.id}>
                          <ReactMarkdown
                            rehypePlugins={[RehypeRaw]}
                            children={c.content}
                          />
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </AppContainer>
    </div>
  )
})

export default FaqPage
